module.exports = __webpack_public_path__ + "2ce54fc13752e841b22436827bb62300.svg";